import { useLocation } from '@remix-run/react';

import useRegion from '~/hooks/useRegion';

const DOMAIN_IDS = {
  DE: '019514b0-de18-750d-973a-daad773a35ed',
  GB: '018df00a-fbc9-74f6-9c16-141d569beb5c'
};

export default function CookiePrompt() {
  const region = useRegion();
  const location = useLocation();

  const domainId =
    DOMAIN_IDS[region.code as keyof typeof DOMAIN_IDS] ?? DOMAIN_IDS.GB;

  if (location.pathname.startsWith('/cl/')) return null;

  return (
    <>
      <script
        src="https://cookie-cdn.cookiepro.com/scripttemplates/otSDKStub.js"
        type="text/javascript"
        data-domain-script={domainId}
        data-language={region.lang}
      ></script>

      <script
        dangerouslySetInnerHTML={{
          __html: 'function OptanonWrapper(){}'
        }}
      />
    </>
  );
}
